module.exports = __webpack_public_path__ + "static/media/icon_salon_open.36fdb13c.svg";